import { Box, Columns, Column, Text, Stack, Card, Badge, IconProfile, IconLocation, Divider } from "braid-design-system";
import React from "react";
import { createPortal } from "react-dom";
import { Schemas } from "../types/api-types";
import { config } from "../config/app.config";





interface CustomerInfoTableProps {
    customerInfo: Schemas['CustomerResponse'] | null;
    onCustomerClick: () => void;
}

const CustomerInfoTable: React.FC<CustomerInfoTableProps> = ({ customerInfo, onCustomerClick }) => {
    const [showPhotoModal, setShowPhotoModel] = React.useState(false);
    const [showSignatureModal, setShowSignatureModal] = React.useState(false);
    const [photoError, setPhotoError] = React.useState(false);
    const [sigError, setSigError] = React.useState(false);

    React.useEffect(() => {
        setPhotoError(false);
        setSigError(false);
    }, [customerInfo?.customer_number]);

    const photoSrc = customerInfo?.customer_number && !photoError
        ? `${config.apiUrl}/customer/${customerInfo.customer_number}/photo`
        : undefined;

    const signatureSrc = customerInfo?.customer_number && !sigError
        ? `${config.apiUrl}/customer/${customerInfo.customer_number}/signature`
        : undefined;



    return (
        <>
            <Box className="premium-card-shadow">
                <Card>
                <Stack space="medium">
                    {/* Header Details */}
                    <Box display="flex" justifyContent="spaceBetween" alignItems="center">
                        <Box display="flex" alignItems="center" style={{ gap: '8px' }}>
                            <IconProfile tone="brandAccent" />
                            <Box cursor="pointer" onClick={onCustomerClick}>
                                <Text weight="strong" size="large" tone="brandAccent">
                                    {customerInfo?.full_name_ln1}
                                </Text>
                            </Box>
                            <Badge tone={customerInfo?.status === 1 ? "positive" : "critical"}>
                                {customerInfo?.status === 1 ? "Active" : "Deactive"}
                            </Badge>
                        </Box>
                        {customerInfo?.customer_number && (
                            <Badge tone="info">No: {customerInfo.customer_number}</Badge>
                        )}
                    </Box>

                    {/* Divider line */}
                    <Divider />

                    {/* Content Columns */}
                    <Columns space="large" alignY="center" collapseBelow="tablet">
                        <Column width="2/3">
                            <Columns space="medium" collapseBelow="tablet">
                                <Column>
                                    <Stack space="small">
                                        <Stack space="xsmall">
                                            <Text size="xsmall" tone="secondary" weight="medium">NIC NUMBER</Text>
                                            <Text size="small" weight="strong" tone="info">{customerInfo?.nic || '-'}</Text>
                                        </Stack>
                                        <Stack space="xsmall">
                                            <Text size="xsmall" tone="secondary" weight="medium">MOBILE PHONE</Text>
                                            <Text size="small" weight="strong" tone="info">{customerInfo?.mobile_1 || '-'}</Text>
                                        </Stack>
                                    </Stack>
                                </Column>
                                <Column>
                                    <Stack space="small">
                                        <Stack space="xsmall">
                                            <Text size="xsmall" tone="secondary" weight="medium">HOME BRANCH</Text>
                                            <Text size="small" weight="strong" tone="info">{customerInfo?.branch?.name_ln1 || '-'}</Text>
                                        </Stack>
                                         <Stack space="xsmall">
                                             <Text size="xsmall" tone="secondary" weight="medium">ADDRESS</Text>
                                             <Text size="small" weight="strong" tone="info" icon={<IconLocation tone="info" />}>
                                                 {customerInfo?.address_ln1 || '-'}
                                             </Text>
                                         </Stack>
                                    </Stack>
                                </Column>
                            </Columns>
                        </Column>
                        <Column width="1/3">
                            <div style={{ display: 'flex', justifyContent: 'center', gap: '24px' }}>
                                <div className="avatar-container">
                                    <div className="avatar-circle" onClick={() => photoSrc && setShowPhotoModel(true)}>
                                        {photoSrc ? (
                                            <img src={photoSrc} onError={() => setPhotoError(true)} alt="Customer" />
                                        ) : (
                                            <svg stroke="#2563eb" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                        )}
                                    </div>
                                    <span className="avatar-label"><Text size="xsmall" align="center" weight="medium">Profile</Text></span>
                                </div>
                                <div className="avatar-container">
                                    <div className="avatar-circle" onClick={() => signatureSrc && setShowSignatureModal(true)}>
                                        {signatureSrc ? (
                                            <img src={signatureSrc} onError={() => setSigError(true)} alt="Customer Signature" />
                                        ) : (
                                            <svg stroke="#2563eb" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="32" width="32" xmlns="http://www.w3.org/2000/svg"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                                        )}
                                    </div>
                                    <span className="avatar-label"><Text size="xsmall" align="center" weight="medium">Signature</Text></span>
                                </div>
                            </div>
                        </Column>
                    </Columns>
                </Stack>
            </Card>
            </Box>
            {showPhotoModal && photoSrc && createPortal(
                <div
                    style={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.7)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000
                    }}
                    onClick={() => setShowPhotoModel(false)}
                >
                    <img
                        src={photoSrc}
                        alt="Customer Large"
                        style={{ maxHeight: "90vh", maxWidth: "90vw", borderRadius: "10px", background: "#fff" }}
                        onClick={e => e.stopPropagation()} // Prevent modal close on image click
                    />
                </div>,
                document.body
            )}
            {showSignatureModal && signatureSrc && createPortal(
                <div
                    style={{
                        position: "fixed",
                        top: 0, left: 0, right: 0, bottom: 0,
                        background: "rgba(0,0,0,0.7)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000
                    }}
                    onClick={() => setShowSignatureModal(false)}
                >
                    <img
                        src={signatureSrc}
                        alt="Customer Signature Large"
                        style={{ maxHeight: "90vh", maxWidth: "90vw", borderRadius: "10px", background: "#fff" }}
                        onClick={e => e.stopPropagation()} // Prevent modal close on image click
                    />
                </div>,
                document.body
            )}
        </>
    )
};

export default CustomerInfoTable;
